// extracted by mini-css-extract-plugin
export default {"DoubleCalander":"DoubleCalander_DoubleCalander__74RY+"};